import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      height: '100%',
      width: 500,
    },
    title: {
      color: theme.palette.primary.main,
    },
    margins: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    square: {
      width: 27,
      height: 3,
      borderRadius: 4,
      marginLeft: theme.spacing(1),
    },
    carCard: {
      backgroundColor: theme.palette.colors.gray5,
      borderRadius: 5,
      padding: theme.spacing(1),
    },
    carCardImage: {
      background: 'rgba(239, 239, 239, 0.5)',
      mixBlendMode: 'multiply',
      borderRadius: '0px 5px 5px 0px',
      margin: -theme.spacing(1),

      '& img': {
        objectFit: 'contain',
        height: 100,
        padding: theme.spacing(2),
      },
    },
  }),
);

export default useStyles;
